import { ReactComponent as AngelListLogo } from './assets/logo-angellist.svg';
import { ReactComponent as FoundersFundLogo } from './assets/logo-founders-fund.svg';
import { ReactComponent as GalaxyLogo } from './assets/logo-galaxy.svg';
import { ReactComponent as HofLogo } from './assets/logo-hof.svg';
import { ReactComponent as SolanaLogo } from './assets/logo-solana.svg';
import { ReactComponent as ValorLogo } from './assets/logo-valor.svg';

export const BACKED_BY_INVESTORS_LOGOS = [
  ValorLogo,
  AngelListLogo,
  GalaxyLogo,
  FoundersFundLogo,
  SolanaLogo,
  HofLogo,
];

export const REPUBLIC_STATS = [
  {
    amount: '2.6',
    prefix: '$',
    suffix: 'B',
    caption: 'Capital deployed',
  },
  {
    amount: '1.5',
    prefix: '$',
    suffix: 'B',
    caption: 'Delegated digital assets',
  },
  {
    amount: '3',
    suffix: 'K',
    caption: 'Global raises supported',
  },
  {
    amount: '95',
    caption:
      'Enterprise clients including Google, SK Planet, Avalanche, Polygon',
  },
  {
    amount: '27',
    caption: 'Portfolio unicorns',
  },
  {
    amount: '3',
    suffix: 'M',
    caption: 'Community members',
  },
];
